module.exports = __webpack_public_path__ + "static/media/nyttarsaftan.3f4e8685.m4a";